


















































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { currentTimestamp, toReadableTime, toTimestamp } from '@/utils/time'
import { Inhaler, PrescriptionsAndInhalers } from '@/jsonapi/DetailedPatient'

@Component({})
export default class InhaledMedication extends Vue {
  @Prop({ required: true }) value!: PrescriptionsAndInhalers
  @Prop({ default: null }) timezone!: string
  @Prop({ default: '' }) title!: string
  @Prop({ default: false }) vibeAssigned: boolean

  private usageAndPuffsList: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
  private asOfDate: string = ''
  private showAsOfIndex: number = -1
  private expiryDate: string = ''
  private showExpiryIndex: number = -1

  private readableTime(timestamp: number) {
    return toReadableTime({ timestamp, format: 'YYYY-MM-DD', timezone: this.timezone })
  }

  private updateEvent() {
    this.$emit('input', this.value)
  }

  private handleAsOfDate(index) {
    const timestamp = toTimestamp(this.asOfDate, this.timezone)
    this.value.inhalers[index].asOfDate = timestamp
    this.showAsOfIndex = -1
  }

  private handleExpiryDate(index) {
    const timestamp = toTimestamp(this.expiryDate, this.timezone)
    this.value.inhalers[index].expiryDate = timestamp
    this.showAsOfIndex = -1
  }

  private newInhaler() {
    const date = new Date().toISOString().slice(0, 10)
    const timestamp = currentTimestamp()
    const inhaler: Inhaler = {
      brand: '',
      dosageRemaining: 0,
      asOfDate: timestamp,
      expiryDate: timestamp,
    }
    this.value.inhalers.push(inhaler)
    this.updateEvent()
  }

  private deleteInhaler(index: number) {
    this.value.inhalers.splice(index, 1)
    this.updateEvent()
  }
}
